import { EventTime } from '../event.time';
import { RecurrenceRule } from '../recurrence.rule';
import { OccurrenceGenerator } from './occurrence.generator';

export class CustomGenerator implements OccurrenceGenerator {
  generate(rule: RecurrenceRule): EventTime[] {
    if (!rule.explicit || rule.explicit.length === 0) return [];

    const seen = new Set<string>();
    const result: EventTime[] = [];
    for (const t of rule.explicit) {
      const key = `${t.startTime}|${t.endTime ?? ''}`;
      if (seen.has(key)) continue;
      seen.add(key);
      result.push({
        startTime: t.startTime,
        endTime: t.endTime ?? null,
        isAllDay: !!t.isAllDay,
        isEndAllDay: !!t.isEndAllDay,
      });
    }
    result.sort((a, b) => (a.startTime < b.startTime ? -1 : a.startTime > b.startTime ? 1 : 0));
    return result;
  }
}
